module.exports = __webpack_public_path__ + "static/media/kspb.d04b0818.png";